import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { ProvinceEditForm } from "@/features/province/ProvinceEditForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function ProvinceEdit() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/province",
            label: "Province",
          },
          {
            label: "Edit",
          },
        ]}
      />
      <H2>Edit Province</H2>
      <ProvinceEditForm id={id} />
    </>
  );
}
